import { render, staticRenderFns } from "./write.vue?vue&type=template&id=6dba8d92"
import script from "./write.vue?vue&type=script&lang=ts"
export * from "./write.vue?vue&type=script&lang=ts"
import style0 from "./write.vue?vue&type=style&index=0&id=6dba8d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports